// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "games.umd.min." + (chunkId === 9 ? "components.tooltipv3" : chunkId) + ".js";
};